import React from 'react';
import { GenericDetailPage } from '../../../components/generic';
import { useSpareCase, SpareCase } from './useData';
import { moduleConfig, getDetailSections, getStatusBadges } from './config';

const Detail: React.FC = () => (
  <GenericDetailPage<SpareCase>
    useData={useSpareCase}
    config={{
      ...moduleConfig,
      getDetailSections,
      getStatusBadges,
    }}
  />
);

export default Detail;
